/* src/app/module/Dashboard/dashboard/add-balance/add-balance.component.scss */
.addBalance-container {
  padding: 0px 24px 24px 24px;
  height: 251px;
  border-radius: 8px;
  z-index: 10000 !important;
}
.addBalance-container h2 {
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  margin: 0px;
  margin-bottom: 24px;
  color: #101828;
}
.addBalance-container .p-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.addBalance-container .p-field label {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 6px;
}
.addBalance-container .p-field .enteramount {
  padding: 10px 14px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: #667085;
  border: 1px solid #D0D5DD;
  background-color: #fff;
  border-radius: 8px;
}
.addBalance-container .p-field .enteramount:focus {
  border-color: orange;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
}
.addBalance-container .p-field .enteramount:hover {
  border-color: none;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
}
.addBalance-container .dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 35px;
}
.addBalance-container .dialog-actions .p-button-secondary {
  border: 1px solid #D0D5DD;
  background-color: #fff;
  color: #344054;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  width: 90px;
  height: 40px;
}
.addBalance-container .dialog-actions .p-button-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.addBalance-container .dialog-actions .p-button-warning {
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  width: 130px;
  height: 44px;
}
.addBalance-container .invalid-input {
  border: 1px solid #e63946 !important;
  background-color: #ffe5e5;
  outline: none;
}
.addBalance-container .error-message {
  color: #e63946;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}
.addBalance-container button[disabled] {
  cursor: not-allowed !important;
}
::ng-deep .p-component-overlay {
  background: var(--Ink-Darkest, #090A0A);
}
::ng-deep .p-dialog .p-dialog-header {
  padding: 32px 22px 32px 22px;
}
.upload-section {
  display: flex;
  align-items: center;
  gap: 24px;
}
.custom-file-upload-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  cursor: pointer;
  background: #f9fafb;
  font-weight: 600;
}
.custom-file-upload-label:hover {
  background: #eaeef1;
}
.hidden-file-input {
  display: none;
}
::ng-deep .addBalance-container .p-dialog {
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
}
::ng-deep .addBalance-container .p-dialog-content {
  padding: 0 1.5rem 2rem 1.5rem;
}
::ng-deep .addBalance-container h2 {
  margin-bottom: 1.5rem;
  font-size: 20px;
  font-weight: 600;
  color: #000;
}
.p-field {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}
.p-field label {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-bottom: 6px;
  margin-top: 10px;
}
::ng-deep input.p-inputtext,
::ng-deep textarea.p-inputtextarea {
  width: 100%;
  height: 44px;
  padding: 10px 14px;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  font-size: 16px;
  background: #fff;
  color: #344054;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.02);
}
::ng-deep textarea.p-inputtextarea {
  height: auto;
  resize: vertical;
  min-height: 100px;
}
::ng-deep input::placeholder,
::ng-deep textarea::placeholder {
  color: #667085;
}
::ng-deep textarea {
  margin-bottom: 4px;
  border-radius: 8px;
  border-color: #D0D5DD;
  padding: 10px;
}
.invalid-input {
  border-color: red !important;
}
.error-message {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}
.file-upload-container {
  margin-bottom: 32px;
  margin-top: 20px;
}
.upload-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
}
.upload-align {
  display: flex;
  gap: 20px;
}
.upload-info-label {
  color: #000;
  font-size: 14px;
  font-weight: 600;
}
.custom-file-upload-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px dashed #D0D5DD;
  border-radius: 8px;
  background: #f9fafb;
  color: #344054;
  cursor: pointer;
}
.hidden-file-input {
  display: none;
}
.file-status-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.file-status {
  font-weight: 500;
  color: #344054;
}
.file-support-info {
  font-size: 12px;
  color: #888;
}
.preview-container {
  margin-top: 1rem;
}
.img-preview {
  max-width: 100px;
  max-height: 100px;
  border-radius: 4px;
}
.pdf-preview {
  color: #3366cc;
  text-decoration: underline;
  font-size: 14px;
}
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 2rem;
}
.btn-primary:disabled,
.btn-primary.p-disabled {
  background: #E1E4E8 !important;
  color: #A0A5AB !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
  transform: none !important;
  border: none !important;
}
::ng-deep form {
  margin-bottom: 0px;
}
::ng-deep .p-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
}
/*# sourceMappingURL=add-balance.component-7NCN3SJZ.css.map */
